export default "__VITE_ASSET__BkBSZV7m__"